'use client';
import ShortenComponent from './s/page';


export default function ShortenPage() {

    return (
        <ShortenComponent />
    );

} 
